import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { maxHeight } from "styled-system";
import { Block, Divider, Tabs } from "reakit";
import { Box, Card, Flex, Image, Text } from "rebass";
import { HorizontalScroll, TabHeader } from "../Base";
import { schoolSelectors } from "../../store/school";
import { authSelectors } from "../../store/auth";
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import styled from "styled-components";

const textProps = {
  ml: 3,
};

/* icon imports */
const PanelWrapper = styled(Card)`
  //min-width: 250px;
  //	height: calc(100vh - 131px);
  //	margin-bottom: 10px;
  max-height: calc(45vh - 65px);
  overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  //@media(max-width: 700px){
  //	height: 70vh;
  //
  //}
  ${maxHeight}
`;

PanelWrapper.defaultProps = {
  maxHeight: ["calc(100vh - 145px)", "calc(45vh - 65px)"],
};

class StudentFilters extends Component {
  state = {
    filters: {
      health: [],
      grade: [],
      location: [],
      dorm: [],
      gender: [],
      type: [],
    },
    selectAll: {
      health: false,
      grade: false,
      dorm: false,
      gender: false,
      type: false,
      location: false,
    },
    rosterSelectAll: false,
  };

  handleSelect = (name, index) => {
    const { filters } = this.props;
    let newFilters = filters;
    let filter = filters[index];
    // console.log('filter', filter);
    let contains = false;
    for (var i = filter.length - 1; i >= 0; i--) {
      if (filter[i] === name) {
        filter.splice(i, 1);
        contains = true;

        newFilters[index] = filter;
      }
    }

    if (!contains) {
      filter.push(name);
      newFilters[index] = filter;
    }

    this.handleUpdateFilters(newFilters);
  };

  handleUpdateFilters = (filters) => {
    const { handleUpdate, isCheckin, handleCheckinUpdate } = this.props;
    if (isCheckin) {
      handleCheckinUpdate(filters);
    } else {
      handleUpdate(filters);
    }
    this.setState({ filters });
  };

  handleSelectAll = (all, index) => {
    const { isCheckin, checkinFilters } = this.props;
    const { selectAll, filters } = this.state;
    // new state starts here
    let newFilters = filters;
    let newSelectAll = selectAll;

    let filter = filters[index];
    // console.log('filter', filter);
    if (all.length === filter.length || selectAll[index] === true) {
      filter = [];
      newSelectAll[index] = false;
    } else {
      if (isCheckin === true) {
        const lockedFilter = checkinFilters[index];
        filter = all.filter((val) => !lockedFilter.includes(val));
        newSelectAll[index] = true;
      } else {
        filter = all;
        newSelectAll[index] = true;
      }
    }

    this.setState({ selectAll: newSelectAll });
    newFilters[index] = filter;
    this.handleUpdateFilters(newFilters);
  };

  renderSelectAll = (all, index) => {
    const { selectAll } = this.state;
    const selected = selectAll[index];
    return (
      <Box width={1}>
        <Flex justifyContent={"flex-start"} flexWrap={"wrap"} pt={2} pb={3}>
          <Text
            ml={3}
            color="blue"
            onClick={() => this.handleSelectAll(all, index)}
          >
            {selected ? "Unselect All" : "Select All"}
          </Text>
        </Flex>
      </Box>
    );
  };

  handleSelectRoster = (data) => {
    const { rosterFilter } = this.props;
    if (rosterFilter.includes(data)) {
      const newData = rosterFilter.filter((obj) => obj.id !== data.id);
      this.props.updateRosterFilter(newData);
    } else {
      const newData = rosterFilter.concat([data]);
      this.props.updateRosterFilter(newData);
    }
  };

  handleSelectAllRoster = (data) => {
    const { rosterSelectAll } = this.state;
    if (rosterSelectAll) {
      this.props.updateRosterFilter([]);
      this.setState({ rosterSelectAll: !this.state.rosterSelectAll });
    } else {
      this.props.updateRosterFilter(data);
      this.setState({ rosterSelectAll: !this.state.rosterSelectAll });
    }
  };

  handleEditButton = (id) => {
    this.props.history.push(`/app/roster/${id}/edit`);
  };

  handleShareButton = (id) => {
    this.props.history.push(`/app/roster/${id}/share`);
  };

  handleDeleteButton = (data) => {
    this.props.handleDeleteRoster(data);
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.filters !== this.props.filters) {
      this.setState({ filters: nextProps.filters });
    }
  }

  render() {
    const {
      filters,
      schoolInfo,
      isLoading,
      dormView,
      isCheckin,
      checkinFilters,
      rosters,
      rosterFilter,
      noLocation,
    } = this.props;
    const { rosterSelectAll } = this.state;

    return (
      <div>
        <Tabs.Container>
          {(tabs) => (
            <Block maxHeight={"45vh"} fontWeight={600}>
              <Tabs width={"100%"}>
                <HorizontalScroll pl={1}>
                  {filters.health && (
                    <Tabs.Tab
                      padding={"15px"}
                      minWidth={"80px"}
                      tab="health"
                      {...tabs}
                    >
                      <TabHeader title={"Health"} />
                    </Tabs.Tab>
                  )}
                  <Tabs.Tab
                    padding={"15px"}
                    minWidth={"80px"}
                    tab="gender"
                    {...tabs}
                  >
                    <TabHeader title={"Gender"} />
                  </Tabs.Tab>
                  <Tabs.Tab
                    padding={"15px"}
                    minWidth={"80px"}
                    tab="grade"
                    {...tabs}
                  >
                    <TabHeader title={"Grade"} />
                  </Tabs.Tab>
                  {!dormView && (
                    <Tabs.Tab
                      minWidth={"80px"}
                      padding={"15px"}
                      tab="dorm"
                      {...tabs}
                    >
                      <TabHeader title={"Dorm"} />
                    </Tabs.Tab>
                  )}
                  {!noLocation && (
                    <Tabs.Tab
                      padding={"15px"}
                      minWidth={"80px"}
                      tab="location"
                      {...tabs}
                    >
                      <TabHeader title={"Location"} />
                    </Tabs.Tab>
                  )}
                  <Tabs.Tab
                    padding={"15px"}
                    minWidth={"80px"}
                    tab="type"
                    {...tabs}
                  >
                    <TabHeader title={"Type"} />
                  </Tabs.Tab>
                  {rosters != null && (
                    <Tabs.Tab padding={"15px"} tab="roster" {...tabs}>
                      <TabHeader title={"Roster"} />
                    </Tabs.Tab>
                  )}
                </HorizontalScroll>
              </Tabs>
              {!isLoading && (
                <Fragment>
                  {filters.health && (
                    <Tabs.Panel tab="health" {...tabs}>
                      <Card mt={"15px"} px={2}>
                        {this.renderSelectAll(
                          ["healthy", "unhealthy", "unsubmitted"],
                          "health"
                        )}
                        <Box width={1}>
                          <Flex
                            onClick={
                              isCheckin &&
                              checkinFilters.health &&
                              checkinFilters.health.includes("healthy")
                                ? () => console.log("check filter")
                                : () => this.handleSelect("healthy", "health")
                            }
                          >
                            <Box>
                              <Text {...textProps} name="healthy">
                                Healthy
                              </Text>
                            </Box>
                            <Box ml={"auto"} />
                            <Box pr={2}>
                              {isCheckin &&
                              checkinFilters.health &&
                              checkinFilters.health.includes("healthy") ? (
                                <Image src={check} />
                              ) : (
                                filters.health.includes("healthy") && (
                                  <Image src={check} />
                                )
                              )}
                            </Box>
                          </Flex>
                        </Box>

                        <Box width={1}>
                          <Divider />
                        </Box>

                        <Flex
                          onClick={
                            isCheckin &&
                            checkinFilters.health &&
                            checkinFilters.health.includes("unhealthy")
                              ? () => console.log("check filter")
                              : () => this.handleSelect("unhealthy", "health")
                          }
                        >
                          <Box>
                            <Text {...textProps} name="unhealthy">
                              Unhealthy
                            </Text>
                          </Box>
                          <Box ml={"auto"} />
                          <Box pr={2}>
                            {isCheckin &&
                            checkinFilters.health &&
                            checkinFilters.health.includes("unhealthy") ? (
                              <Image src={check} />
                            ) : (
                              filters.health.includes("unhealthy") && (
                                <Image src={check} />
                              )
                            )}
                          </Box>
                        </Flex>
                        <Divider />
                        <Flex
                          onClick={
                            isCheckin &&
                            checkinFilters.health &&
                            checkinFilters.health.includes("unsubmitted")
                              ? () => console.log("check filter")
                              : () => this.handleSelect("unsubmitted", "health")
                          }
                        >
                          <Box>
                            <Text {...textProps} name="unsubmitted">
                              Unsubmitted
                            </Text>
                          </Box>
                          <Box ml={"auto"} />
                          <Box pr={2}>
                            {isCheckin &&
                            checkinFilters.health &&
                            checkinFilters.health.includes("unsubmitted") ? (
                              <Image src={check} />
                            ) : (
                              filters.health.includes("unsubmitted") && (
                                <Image src={check} />
                              )
                            )}
                          </Box>
                        </Flex>
                        <Divider />
                      </Card>
                    </Tabs.Panel>
                  )}
                  {!dormView && (
                    <Tabs.Panel tab="dorm" {...tabs}>
                      <PanelWrapper mt={"15px"} px={2}>
                        {this.renderSelectAll(
                          schoolInfo.subDorms.map((dorm) => dorm.id),
                          "dorm"
                        )}

                        {schoolInfo.subDorms.map((item) => (
                          <Box
                            width={1}
                            key={item.id}
                            onClick={
                              isCheckin &&
                              checkinFilters.dorm &&
                              checkinFilters.dorm.includes(item.id)
                                ? () => console.log("check filter")
                                : () => this.handleSelect(item.id, "dorm")
                            }
                          >
                            <Flex>
                              <Box>
                                <Text color={"black"} {...textProps}>
                                  {item.name}
                                </Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {isCheckin &&
                                checkinFilters.dorm &&
                                checkinFilters.dorm.includes(item.id) ? (
                                  <Image src={check} />
                                ) : (
                                  filters.dorm.includes(item.id) && (
                                    <Image src={check} />
                                  )
                                )}
                              </Box>
                            </Flex>
                            <Box width={1}>
                              <Divider />
                            </Box>
                          </Box>
                        ))}
                      </PanelWrapper>
                    </Tabs.Panel>
                  )}
                  {!noLocation && (
                    <Tabs.Panel tab="location" {...tabs}>
                      <PanelWrapper mt={"15px"} px={2}>
                        {this.renderSelectAll(
                          schoolInfo.locations.list
                            .filter((l) => l.activated)
                            .map((item) => item.id),
                          "location"
                        )}

                        {schoolInfo.locations.list
                          .filter((l) => l.activated)
                          .map((location) => (
                            <Box
                              width={1}
                              key={location.id}
                              onClick={
                                isCheckin &&
                                checkinFilters.location &&
                                checkinFilters.location.includes(location.id)
                                  ? () => console.log("check filter")
                                  : () =>
                                      this.handleSelect(location.id, "location")
                              }
                            >
                              <Flex>
                                <Box>
                                  <Text color={"black"} {...textProps}>
                                    {location.name}
                                  </Text>
                                </Box>
                                <Box ml={"auto"} />
                                <Box pr={2}>
                                  {isCheckin &&
                                  checkinFilters.location &&
                                  checkinFilters.location.includes(
                                    location.id
                                  ) ? (
                                    <Image src={check} />
                                  ) : (
                                    filters.location.includes(location.id) && (
                                      <Image src={check} />
                                    )
                                  )}
                                </Box>
                              </Flex>
                              <Box width={1}>
                                <Divider />
                              </Box>
                            </Box>
                          ))}
                      </PanelWrapper>
                    </Tabs.Panel>
                  )}
                  <Tabs.Panel tab="gender" {...tabs}>
                    <Card mt={"15px"} px={2}>
                      {this.renderSelectAll(["M", "F"], "gender")}
                      <Box width={1}>
                        <Flex
                          onClick={
                            isCheckin &&
                            checkinFilters.gender &&
                            checkinFilters.gender.includes("F")
                              ? () => console.log("check filter")
                              : () => this.handleSelect("F", "gender")
                          }
                        >
                          <Box>
                            <Text {...textProps} name="male">
                              Female
                            </Text>
                          </Box>
                          <Box ml={"auto"} />
                          <Box pr={2}>
                            {isCheckin &&
                            checkinFilters.gender &&
                            checkinFilters.gender.includes("F") ? (
                              <Image src={check} />
                            ) : (
                              filters.gender.includes("F") && (
                                <Image src={check} />
                              )
                            )}
                          </Box>
                        </Flex>
                      </Box>

                      <Box width={1}>
                        <Divider />
                      </Box>

                      <Flex
                        onClick={
                          isCheckin &&
                          checkinFilters.gender &&
                          checkinFilters.gender.includes("M")
                            ? () => console.log("check filter")
                            : () => this.handleSelect("M", "gender")
                        }
                      >
                        <Box>
                          <Text {...textProps} name="male">
                            Male
                          </Text>
                        </Box>
                        <Box ml={"auto"} />
                        <Box pr={2}>
                          {isCheckin &&
                          checkinFilters.gender &&
                          checkinFilters.gender.includes("M") ? (
                            <Image src={check} />
                          ) : (
                            filters.gender.includes("M") && (
                              <Image src={check} />
                            )
                          )}
                        </Box>
                      </Flex>
                      <Divider />
                    </Card>
                  </Tabs.Panel>

                  <Tabs.Panel tab="grade" {...tabs}>
                    <PanelWrapper mt={"15px"} px={2}>
                      {this.renderSelectAll(["3", "4", "5", "6"], "grade")}

                      <Flex flexWrap={"wrap"} flexDirection={"column"}>
                        <Flex
                          onClick={
                            isCheckin &&
                            checkinFilters.grade &&
                            checkinFilters.grade.includes("3")
                              ? () => console.log("check filter")
                              : () => this.handleSelect("3", "grade")
                          }
                        >
                          <Box>
                            <Text {...textProps}>3rd Form</Text>
                          </Box>
                          <Box ml={"auto"} />
                          <Box pr={2}>
                            {isCheckin && checkinFilters.grade.includes("3") ? (
                              <Image src={check} />
                            ) : (
                              filters.grade.includes("3") && (
                                <Image src={check} />
                              )
                            )}
                          </Box>
                        </Flex>
                        <Divider />
                        <Flex
                          onClick={
                            isCheckin &&
                            checkinFilters.grade &&
                            checkinFilters.grade.includes("4")
                              ? () => console.log("check filter")
                              : () => this.handleSelect("4", "grade")
                          }
                        >
                          <Box>
                            <Text {...textProps}>4th Form</Text>
                          </Box>
                          <Box ml={"auto"} />
                          <Box pr={2}>
                            {isCheckin && checkinFilters.grade.includes("4") ? (
                              <Image src={check} />
                            ) : (
                              filters.grade.includes("4") && (
                                <Image src={check} />
                              )
                            )}
                          </Box>
                        </Flex>
                        <Divider />
                        <Flex
                          onClick={
                            isCheckin &&
                            checkinFilters.grade &&
                            checkinFilters.grade.includes("5")
                              ? () => console.log("check filter")
                              : () => this.handleSelect("5", "grade")
                          }
                        >
                          <Box>
                            <Text {...textProps}>5th Form</Text>
                          </Box>
                          <Box ml={"auto"} />
                          <Box pr={2}>
                            {isCheckin &&
                            checkinFilters.grade &&
                            checkinFilters.grade.includes("5") ? (
                              <Image src={check} />
                            ) : (
                              filters.grade.includes("5") && (
                                <Image src={check} />
                              )
                            )}
                          </Box>
                        </Flex>
                        <Divider />
                        <Flex
                          onClick={
                            isCheckin &&
                            checkinFilters.grade &&
                            checkinFilters.grade.includes("6")
                              ? () => console.log("check filter")
                              : () => this.handleSelect("6", "grade")
                          }
                        >
                          <Box>
                            <Text {...textProps}>6th Form</Text>
                          </Box>
                          <Box ml={"auto"} />
                          <Box pr={2}>
                            {isCheckin &&
                            checkinFilters.grade &&
                            checkinFilters.grade.includes("6") ? (
                              <Image src={check} />
                            ) : (
                              filters.grade.includes("6") && (
                                <Image src={check} />
                              )
                            )}
                          </Box>
                        </Flex>
                        <Divider />
                      </Flex>
                    </PanelWrapper>
                  </Tabs.Panel>

                  <Tabs.Panel tab="type" {...tabs}>
                    <Card mt={"15px"} px={2}>
                      {this.renderSelectAll(["D", "B"], "type")}

                      <Box width={1}>
                        <Flex
                          onClick={
                            isCheckin &&
                            checkinFilters.type &&
                            checkinFilters.type.includes("D")
                              ? () => console.log("check filter")
                              : () => this.handleSelect("D", "type")
                          }
                        >
                          <Box>
                            <Text {...textProps} name="male">
                              Day
                            </Text>
                          </Box>
                          <Box ml={"auto"} />
                          <Box pr={2}>
                            {isCheckin &&
                            checkinFilters.type &&
                            checkinFilters.type.includes("D") ? (
                              <Image src={check} />
                            ) : (
                              filters.type &&
                              filters.type.includes("D") && (
                                <Image src={check} />
                              )
                            )}
                          </Box>
                        </Flex>
                      </Box>

                      <Box width={1}>
                        <Divider />
                      </Box>

                      <Flex
                        onClick={
                          isCheckin &&
                          checkinFilters.type &&
                          checkinFilters.type.includes("B")
                            ? () => console.log("check filter")
                            : () => this.handleSelect("B", "type")
                        }
                      >
                        <Box>
                          <Text {...textProps} name="male">
                            Boarding
                          </Text>
                        </Box>
                        <Box ml={"auto"} />
                        <Box pr={2}>
                          {isCheckin &&
                          checkinFilters.type &&
                          checkinFilters.type.includes("B") ? (
                            <Image src={check} />
                          ) : (
                            filters.type &&
                            filters.type.includes("B") && <Image src={check} />
                          )}
                        </Box>
                      </Flex>
                      <Divider />
                    </Card>
                  </Tabs.Panel>

                  {
                    <Tabs.Panel tab="roster" {...tabs}>
                      <PanelWrapper mt={"15px"} px={2}>
                        <Box width={1}>
                          <Flex
                            justifyContent={"space-between"}
                            flexWrap={"wrap"}
                            pt={2}
                            pb={3}
                          >
                            <Text
                              ml={3}
                              color="blue"
                              onClick={() =>
                                this.handleSelectAllRoster(rosters)
                              }
                            >
                              {rosterSelectAll ? "Unselect All" : "Select All"}
                            </Text>
                            <Text
                              mr={3}
                              color="blue"
                              onClick={() =>
                                this.props.history.push("/app/roster/new")
                              }
                            >
                              + Add New
                            </Text>
                          </Flex>
                        </Box>
                        {rosters != null &&
                          rosters.map((roster) => (
                            <Box
                              width={1}
                              key={roster.id}
                              onClick={() => this.handleSelectRoster(roster)}
                            >
                              <Flex alignItems={"center"}>
                                <Box>
                                  <Flex alignItems={"center"}>
                                    <Text color={"black"} {...textProps}>
                                      {roster.name}
                                    </Text>
                                  </Flex>
                                </Box>
                                <Box ml={"auto"} />
                                {rosterFilter.includes(roster) && (
                                  <Image pr={2} src={check} />
                                )}
                              </Flex>
                              <Box width={1}>
                                <Divider />
                              </Box>
                            </Box>
                          ))}
                      </PanelWrapper>
                    </Tabs.Panel>
                  }
                </Fragment>
              )}
            </Block>
          )}
        </Tabs.Container>
      </div>
    );
  }
}

StudentFilters.propTypes = {
  dormView: PropTypes.bool,
  noLocation: PropTypes.bool,
  isCheckin: PropTypes.bool,
  filters: PropTypes.object,
  checkinFilter: PropTypes.object,
  handleUpdate: PropTypes.func,
};

StudentFilters.defaultProps = {
  dormView: false,
  isCheckin: false,
  filters: {
    grade: [],
    location: [],
    dorm: [],
    gender: [],
    type: [],
  },
  checkinFilters: {
    grade: [],
    location: [],
    dorm: [],
    gender: [],
    type: [],
  },
  handleUpdate: (filters) => console.log("filters handleUpdate", filters),
  noLocation: false,
};

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
  profileInfo: authSelectors.refreshProfile(state.auth),
  loading: authSelectors.isLoading(state.auth),
  isLoading: schoolSelectors.isLoading(state.school),
});
export default withRouter(connect(mapStateToProps)(StudentFilters));
